module.exports = __webpack_public_path__ + "img/rantautumispaikka_original.cc560db7.jpg";